import { compose } from "redux";
import { withRouter } from 'react-router';
import dataFetcher from 'Parts/chore/dataFetcher';
import { connect } from "react-redux";

import CampaignsSettingsAdvancedPage from './CampaignsSettingsAdvancedPage';

const mapStateToProps = state => ({
  campaign: state.campaign.campaign,
  locale: state.session.language
});

export default compose(
  connect(mapStateToProps),
  withRouter,
  dataFetcher
)(CampaignsSettingsAdvancedPage);
